import { useState } from 'react'
import type { MouseEvent, ReactNode } from 'react'

// 칸에 마우스를 올리면 아래에 뜨는 말풍선 — 스크롤 영역에 잘리지 않게 화면 고정 위치로 띄운다
export interface TipContent {
  title: string
  value?: string // 고정폭 글꼴로 보일 값 (빈 문자열이면 "(비어 있음)")
  note?: string
}

export function useHoverTip() {
  const [tip, setTip] = useState<(TipContent & { x: number; y: number }) | null>(null)

  const tipProps = (content: TipContent | undefined) => content === undefined ? {} : {
    onMouseEnter: (e: MouseEvent<HTMLElement>) => {
      const r = e.currentTarget.getBoundingClientRect()
      setTip({ ...content, x: Math.min(r.left, window.innerWidth - 310), y: r.bottom + 4 })
    },
    onMouseLeave: () => setTip(null),
  }

  const tipNode: ReactNode = tip && (
    <div className="fixed z-[60] max-w-[300px] rounded-lg bg-gray-900 text-white text-xs px-3 py-2 shadow-lg pointer-events-none" style={{ left: tip.x, top: tip.y }}>
      <div className="text-gray-400 text-[11px]">{tip.title}</div>
      {tip.value !== undefined && <div className="font-mono break-all mt-0.5">{tip.value || <span className="text-gray-500">(비어 있음)</span>}</div>}
      {tip.note && <div className="text-gray-400 text-[11px] mt-1">{tip.note}</div>}
    </div>
  )

  return { tipProps, tipNode, hideTip: () => setTip(null) }
}
